import { Info } from 'lucide-react';
import type { TechnicianPensieveStats } from '@/hooks/useTechnicianPensieveStats';
import { PassportProvenanceBadge } from './PassportProvenanceBadge';

interface PassportPensieveSummaryProps {
  stats: TechnicianPensieveStats | undefined;
  className?: string;
}

export function PassportPensieveSummary({
  stats,
  className,
}: PassportPensieveSummaryProps) {
  if (!stats || !stats.hasData) {
    return (
      <div
        className={`flex items-center gap-1 text-[11px] text-muted-foreground ${className ?? ''}`}
      >
        <Info className="h-3 w-3" />
        <span>
          OptiTime is still building learning data for this technician.
        </span>
      </div>
    );
  }

  const { combosCount, totalCompletions, avgDeltaPercent } = stats;

  let trendLabel: string | null = null;
  if (avgDeltaPercent != null && totalCompletions >= 10) {
    const rounded = Math.round(avgDeltaPercent);
    if (rounded <= -5) {
      trendLabel = `about ${Math.abs(rounded)}% faster than book on average`;
    } else if (rounded >= 5) {
      trendLabel = `about ${rounded}% slower than book on average`;
    } else {
      trendLabel = `very close to book time on average`;
    }
  }

  return (
    <div
      className={`flex flex-wrap items-center gap-1 text-[11px] text-muted-foreground ${className ?? ''}`}
    >
      <Info className="h-3 w-3" />
      <span>
        OptiTime has learned{' '}
        <strong className="font-medium">{combosCount}</strong> vehicle/job
        combos across{' '}
        <strong className="font-medium">{totalCompletions}</strong> completed
        jobs
        {trendLabel ? `, ${trendLabel}.` : '.'}
      </span>
      <PassportProvenanceBadge factGroupId="pensieve-learning" className="text-[10px]" />
    </div>
  );
}
